import { useEffect } from 'react';

/**
 * Registers a window keydown listener that invokes `onClose` when the Escape
 * key is pressed. Pass `{ disabled: true }` to suppress without unmounting.
 *
 * Callers should pass a stable `onClose` (e.g. `useCallback`-wrapped) — the
 * hook re-binds whenever the identity of `onClose` or `disabled` changes.
 */
export function useEscToClose(
  onClose: () => void,
  opts?: { disabled?: boolean }
): void {
  const disabled = opts?.disabled;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !disabled) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, disabled]);
}
